import React, { useEffect, useState } from 'react';
import './App.css';
import { auth, db } from './services/firebase';
import { onAuthStateChanged, User } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import AuthPage from './AuthPage';
import WelcomePage from './WelcomePage';
import AdminPage from './AdminPage';
import LogoHeader from './LogoHeader';
import PromoPage from './PromoPage';
import ScratchGamePage from './ScratchGamePage';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { isOnline, setupConnectivityListeners } from './utils/connectivity';
import UpdateNotification from './components/UpdateNotification';
import { Box } from '@mui/material';

function App() {
  const [user, setUser] = useState<User | null | undefined>(undefined);
  const [userData, setUserData] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [isOffline, setIsOffline] = useState(!isOnline());

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        setLoading(true);
        const docSnap = await getDoc(doc(db, "utenti", firebaseUser.uid));
        if (docSnap.exists()) {
          setUserData({ ...firebaseUser, ...docSnap.data() });
        } else {
          setUserData(null);
        }
        setLoading(false);
      } else {
        setUserData(null);
        setLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const cleanup = setupConnectivityListeners(
      () => setIsOffline(false),
      () => setIsOffline(true)
    );
    
    return cleanup;
  }, []);

  if (user === undefined || loading) {
    // Mostra caricamento solo mentre carica i dati Firestore
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ color: '#2a5298', fontWeight: 600 }}>Caricamento dati...</span>
      </div>
    );
  }

  if (!user) {
    return <AuthPage />;
  }

  if (userData?.admin) {
    return <AdminPage />;
  }

  return (
    <>
      <LogoHeader />

      {/* Bottone flottante gratta e vinci */}
      {!userData?.admin && location.pathname !== '/scratch' && (
        <button
          onClick={() => navigate('/scratch')}
          style={{
            position: 'fixed',
            bottom: 96, // <-- aumenta questo valore per salire il bottone
            right: 32,
            zIndex: 1000,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            outline: 'none',
            animation: 'spin-coin 1.2s linear infinite',
          }}
        >
          <img
            src="/coin.png"
            alt="Gratta e Vinci"
            style={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              boxShadow: '0 4px 16px #b6c6e6',
              background: '#fffbe7',
            }}
          />
        </button>
      )}

      {isOffline && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '#f44336',
            color: 'white',
            textAlign: 'center',
            padding: 1,
            zIndex: 9999
          }}
        >
          Sei offline. Alcune funzionalità potrebbero non essere disponibili.
        </Box>
      )}

      <Routes>
        <Route path="/promo" element={<PromoPage />} />
        <Route path="/scratch" element={<ScratchGamePage user={userData} />} />
        <Route path="*" element={<WelcomePage user={userData} />} />
      </Routes>

      <UpdateNotification />

      {/* Animazione CSS */}
      <style>
        {`
          @keyframes spin-coin {
            0% { transform: rotateY(0deg);}
            100% { transform: rotateY(360deg);}
          }
          button:active img {
            filter: brightness(0.9);
          }
        `}
      </style>
    </>
  );
}

export default App;